// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__sDTut","header":"Users_header__2UlNA","tableHeader":"Users_tableHeader__3-z2T"};